import { motion } from 'framer-motion';
import { forwardRef } from 'react';
import { FiPlus } from 'react-icons/fi';
import { modalAnimVariants } from '../../../constants/animationVariants';

// datatype of parent modal props declared here
interface IParentModal {
  children: React.ReactNode;
  customWidthClass?: string;
  onClick: () => void;
  hideCloseButton?: boolean;
  makeBgBlur?: boolean;
}

const ParentModal = forwardRef<HTMLDivElement, IParentModal>((props, ref) => {
  // destructuring the props object here
  const { children, customWidthClass, onClick, hideCloseButton, makeBgBlur } =
    props || {};

  // rendering parent modal component here
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className={`font-lato fixed overflow-y-auto h-screen w-screen left-0 top-0 z-[9999] bg-black/25 ${
        makeBgBlur ? 'backdrop-blur-md' : ''
      }`}
    >
      <div className='mx-auto min-h-screen flex items-center'>
        <motion.div
          className={`relative mx-auto p-6 w-[95%] bg-white rounded-xl my-5 z-20 ${
            customWidthClass ? customWidthClass : 'md:w-[500px]'
          }`}
          variants={modalAnimVariants}
          initial='hidden'
          animate='visible'
          exit='exit'
        >
          {!hideCloseButton ? (
            <button
              onClick={onClick}
              className='absolute right-3 top-3 text-legal-dark-blue hover:text-base-red duration-300'
            >
              <FiPlus className='rotate-45 h-8 w-8' />
            </button>
          ) : null}

          <div className='space-y-3'>{children}</div>
        </motion.div>
      </div>

      <div onClick={onClick} className='fixed left-0 top-0 h-full w-full'></div>
    </motion.div>
  );
});

export default ParentModal;
